<template>
  <div>
    <el-form :label-position="labelPosition" label-width="0px" :model="formLabelAlign">
      <el-form-item label="">
        <el-select @change="update" v-model="attrId" placeholder="--请选择属性--">
          <el-option
            v-for="item in attrOptions"
            :key="item.identity"
            :label="item.name"
            :value="item.identity">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="">
        <el-select @change="update" v-model="conditionValue">
          <el-option
            v-for="item in conditionOptions"
            :key="item.id"
            :label="item.label"
            :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <el-form label-width="0px" v-for="(item, index) in branchArray" :key="item.branchName">
      <el-form-item style="text-align: left;">
        <span style="margin-left: 45px;"><i style="color: #f56c6c">* </i>分支{{ index + 1 }}:</span>
        <el-input @change="update" v-model="item.value" style="width: 300px;" v-bind:class="{ inputWidth: item.branchIndex === 1 }"></el-input>
        <el-button style="width: 20px; height: 20px; line-height: 20px; padding: 0px;border: none;color: red" @click="deleteBranchAction(index)"  v-bind:class="{ isShow: item.branchIndex === 1 }">x</el-button>
      </el-form-item>
    </el-form>
    <el-form>
      <el-form-item label-width="95px" :label="barnchCount + branchLast" style="text-align: left;">
        <span>其他</span>
      </el-form-item>
    </el-form>
    <el-button @click="addBranchAction">添加分支</el-button>
  </div>
</template>

<script>
import { getCustomerAttributeList } from '@/api/customer.js'
export default {
  name: '',
  props: ['contents'],
  data () {
    return {
      conditionValue: this.contents.conditionValue,
      attrId: this.contents.attrId,
      conditionOptions: [
        {
          id: 1,
          label: '等于'
        },
        {
          id: 2,
          label: '包含'
        }
      ],
      barnchCount: '分支',
      branchLast: '',
      branchArray: this.contents.content,
      addGroupName: '加入群组',
      attrOptions: [],
      value: '',
      labelPosition: 'right',
      formLabelAlign: {
        name: '',
        region: '',
        type: ''
      },
      choose: {}
    }
  },
  computed: {
  },
  methods: {
    // 传值到父组件
    update() {
      // 传值到父组件
      this.choose.nodeType = 'attrBranchNode'
      this.choose.attrId = this.attrId
      this.choose.conditionValue = this.conditionValue
      this.choose.content = this.branchArray
      this.choose.id = this.contents.id
      this.$emit('change', this.choose)
    },
    loadCustomerAttr() {
      getCustomerAttributeList().then((res) => {
        if (res.data.code === 0) {
          let data = res.data.data
          let remainData = []
          // 循环删除省市区国家以及checkbox的元素  并且radio的改为select
          for (let i in data) {
            if (data[i].identity === 'district' || data[i].identity === 'city' || data[i].identity === 'province' || data[i].identity === 'country' || data[i].identity === 'stage_id' || data[i].identity === 'source_id') {
              continue
            }
            if (data[i].is_system === 0) {
              continue
            }
            remainData.push(data[i])
          }
          // 拼接处理获得的属性列表到本地数据
          for (let i in remainData) {
            remainData[i].value = remainData[i].identity + '@' + remainData[i].type
            remainData[i].label = remainData[i].name
          }
          remainData.push({
            name: '区域',
            identity: 'systemPcd',
            type: 'addressPicker',
            option: []
          })
          this.attrOptions = remainData
          console.log('getCustomerAttributeList', this.attrOptions)
        }
      })
    },
    addBranchAction() {
      this.branchArray.push({
        branchIndex: this.branchArray.length + 1,
        value: ''
      })
      this.branchLast = this.branchArray.length + 1
      this.update()
    },
    deleteBranchAction(index) {
      if (this.branchArray.length > 1) {
        this.branchArray.splice(index, 1)
        this.branchLast = this.branchArray.length + 1
      }
    }
  },
  watch: {
    contents: function (val) {
      this.branchArray = val.content
      this.attrId = val.attrId
      this.conditionValue = val.conditionValue
      console.log('contents', val)
    }
  },
  created() {
    this.loadCustomerAttr()
    this.branchLast = this.branchArray.length + 1
    console.log('contents2', this.contents)
  }
}
</script>

<style scoped>

</style>
